import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Auth from '../Components/auth';
import { FaCoins } from 'react-icons/fa';

function Business() {



    return (
        <div>
            <Auth />
            <div className="header is-fixed">
                <div className="tf-container">
                    <div className="tf-statusbar d-flex justify-content-center align-items-center">
                        <Link to="/" className="back-btn"> <i className="icon-left" /> </Link>
                        <h3>Business</h3>
                    </div>
                </div>
            </div>
            <div id="app-wrap">
                <div className="app-section st1 mt-1 bg_white_color">
                    <div className="tf-container">
                        <div className="wrap-total">
                            <Link to="/Myreward">
                                <div className="total-item">
                                    <div className="content">
                                        <p className="fw_4">My Business</p>
                                        <p className="fw_6 success_color">$ {localStorage.getItem('myBusiness')}</p>
                                    </div>
                                </div>
                            </Link>
                            <Link to="/teamreward">
                                <div className="total-item">

                                    <div className="content">
                                        <p className="fw_4">Team Business</p>
                                        <p className="fw_6 primary_color">$ {localStorage.getItem('allBusiness')}</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="app-section st1 mt-1 mb-5 bg_white_color">
                    <div className="tf-container">
                        <div className="trading-month">
                            <div className="group-trading-history mb-5">
                                <Link className="tf-trading-history" to="javascript:void(0)">
                                    <div className="inner-left">
                                        <div className="icon-box">
                                            <FaCoins />
                                        </div>
                                        <div className="content">
                                            <h4>Level 1</h4>
                                        </div>
                                    </div>
                                    <span className="num-val success_color ">{localStorage.getItem('businessLevel1')}</span>
                                </Link>

                                <Link className="tf-trading-history" to="javascript:void(0)">
                                    <div className="inner-left">
                                        <div className="icon-box">
                                            <FaCoins />
                                        </div>
                                        <div className="content">
                                            <h4>Level 2</h4>
                                        </div>
                                    </div>
                                    <span className="num-val success_color ">{localStorage.getItem('businessLevel2')}</span>
                                </Link>

                                <Link className="tf-trading-history" to="javascript:void(0)">
                                    <div className="inner-left">
                                        <div className="icon-box">
                                            <FaCoins />
                                        </div>
                                        <div className="content">
                                            <h4>Level 3</h4>
                                        </div>
                                    </div>
                                    <span className="num-val success_color ">{localStorage.getItem('businessLevel3')}</span>
                                </Link>

                                <Link className="tf-trading-history" to="javascript:void(0)">
                                    <div className="inner-left">
                                        <div className="icon-box">
                                            <FaCoins />
                                        </div>
                                        <div className="content">
                                            <h4>Level 4</h4>
                                        </div>
                                    </div>
                                    <span className="num-val success_color ">{localStorage.getItem('businessLevel4')}</span>
                                </Link>

                                <Link className="tf-trading-history" to="javascript:void(0)">
                                    <div className="inner-left">
                                        <div className="icon-box">
                                            <FaCoins />
                                        </div>
                                        <div className="content">
                                            <h4>Level 5</h4>
                                        </div>
                                    </div>
                                    <span className="num-val success_color ">{localStorage.getItem('businessLevel5')}</span>
                                </Link>

                                <Link className="tf-trading-history" to="javascript:void(0)">
                                    <div className="inner-left">
                                        <div className="icon-box">
                                            <FaCoins />
                                        </div>
                                        <div className="content">
                                            <h4>Level 6</h4>
                                        </div>
                                    </div>
                                    <span className="num-val success_color ">{localStorage.getItem('businessLevel6')}</span>
                                </Link>

                                <Link className="tf-trading-history" to="javascript:void(0)">
                                    <div className="inner-left">
                                        <div className="icon-box">
                                            <FaCoins />
                                        </div>
                                        <div className="content">
                                            <h4>Level 7</h4>
                                        </div>
                                    </div>
                                    <span className="num-val success_color ">{localStorage.getItem('businessLevel7')}</span>
                                </Link>

                                <Link className="tf-trading-history" to="javascript:void(0)">
                                    <div className="inner-left">
                                        <div className="icon-box">
                                            <FaCoins />
                                        </div>
                                        <div className="content">
                                            <h4>Level 8</h4>
                                        </div>
                                    </div>
                                    <span className="num-val success_color ">{localStorage.getItem('businessLevel8')}</span>
                                </Link>

                                <Link className="tf-trading-history" to="javascript:void(0)">
                                    <div className="inner-left">
                                        <div className="icon-box">
                                            <FaCoins />
                                        </div>
                                        <div className="content">
                                            <h4>Level 9</h4>
                                        </div>
                                    </div>
                                    <span className="num-val success_color ">{localStorage.getItem('businessLevel9')}</span>
                                </Link>

                                <Link className="tf-trading-history" to="javascript:void(0)">
                                    <div className="inner-left">
                                        <div className="icon-box">
                                            <FaCoins />
                                        </div>
                                        <div className="content">
                                            <h4>Level 10</h4>
                                        </div>
                                    </div>
                                    <span className="num-val success_color ">{localStorage.getItem('businessLevel10')}</span>
                                </Link>

                                <Link className="tf-trading-history" to="javascript:void(0)">
                                    <div className="inner-left">
                                        <div className="icon-box">
                                            <FaCoins />
                                        </div>
                                        <div className="content">
                                            <h4>Level 11</h4>
                                        </div>
                                    </div>
                                    <span className="num-val success_color ">{localStorage.getItem('businessLevel11')}</span>
                                </Link>

                                <Link className="tf-trading-history" to="javascript:void(0)">
                                    <div className="inner-left">
                                        <div className="icon-box">
                                            <FaCoins />
                                        </div>
                                        <div className="content">
                                            <h4>Level 12</h4>
                                        </div>
                                    </div>
                                    <span className="num-val success_color ">{localStorage.getItem('businessLevel12')}</span>
                                </Link>

                                <Link className="tf-trading-history" to="javascript:void(0)">
                                    <div className="inner-left">
                                        <div className="icon-box">
                                            <FaCoins />
                                        </div>
                                        <div className="content">
                                            <h4>Level 13</h4>
                                        </div>
                                    </div>
                                    <span className="num-val success_color ">{localStorage.getItem('businessLevel13')}</span>
                                </Link>

                                <Link className="tf-trading-history" to="javascript:void(0)">
                                    <div className="inner-left">
                                        <div className="icon-box">
                                            <FaCoins />
                                        </div>
                                        <div className="content">
                                            <h4>Level 14</h4>
                                        </div>
                                    </div>
                                    <span className="num-val success_color ">{localStorage.getItem('businessLevel14')}</span>
                                </Link>

                                <Link className="tf-trading-history" to="javascript:void(0)">
                                    <div className="inner-left">
                                        <div className="icon-box">
                                            <FaCoins />
                                        </div>
                                        <div className="content">
                                            <h4>Level 15</h4>
                                        </div>
                                    </div>
                                    <span className="num-val success_color ">{localStorage.getItem('businessLevel15')}</span>
                                </Link>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Footer */}
            <div className="bottom-navigation-bar">
                <div className="tf-container">
                    <ul className="tf-navigation-bar">
                        <li>
                            <Link className="fw_4 d-flex justify-content-center align-items-center flex-column" to="/"><i className="icon-home" /> Home</Link>
                        </li>
                        <li className="active"><Link className="fw_4 d-flex justify-content-center align-items-center flex-column" to="/history"><i className="icon-history" /> History</Link> </li>
                        <li><Link className="fw_4 d-flex justify-content-center align-items-center flex-column" to="/qr-code"><i className="icon-scan-qr-code" /> </Link> </li>
                        <li><Link className="fw_4 d-flex justify-content-center align-items-center flex-column" to="/rewards"><svg width={25} height={24} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12.25" cy={12} r="9.5" stroke="#717171" />
                            <path d="M17.033 11.5318C17.2298 11.3316 17.2993 11.0377 17.2144 10.7646C17.1293 10.4914 16.9076 10.2964 16.6353 10.255L14.214 9.88781C14.1109 9.87213 14.0218 9.80462 13.9758 9.70702L12.8933 7.41717C12.7717 7.15989 12.525 7 12.2501 7C11.9754 7 11.7287 7.15989 11.6071 7.41717L10.5244 9.70723C10.4784 9.80483 10.3891 9.87234 10.286 9.88802L7.86469 10.2552C7.59257 10.2964 7.3707 10.4916 7.2856 10.7648C7.2007 11.038 7.27018 11.3318 7.46702 11.532L9.2189 13.3144C9.29359 13.3905 9.32783 13.5 9.31021 13.607L8.89692 16.1239C8.86027 16.3454 8.91594 16.5609 9.0533 16.7308C9.26676 16.9956 9.6394 17.0763 9.93735 16.9128L12.1027 15.7244C12.1932 15.6749 12.3072 15.6753 12.3975 15.7244L14.563 16.9128C14.6684 16.9707 14.7807 17 14.8966 17C15.1083 17 15.3089 16.9018 15.4469 16.7308C15.5845 16.5609 15.6399 16.345 15.6033 16.1239L15.1898 13.607C15.1722 13.4998 15.2064 13.3905 15.2811 13.3144L17.033 11.5318Z" stroke="#717171" strokeWidth="1.25" />
                        </svg>
                            Rewards</Link> </li>
                        <li><Link className="fw_4 d-flex justify-content-center align-items-center flex-column" to="/profile"><i className="icon-user-outline" /> Profile</Link> </li>
                    </ul>
                    {/* <span class="line"></span> */}
                </div>
            </div>
            {/* <Footer/> */}
        </div>
    );

}

export default Business